import { createContext, useContext } from "react";

import { TrackPayload } from "@repo/edtech-analytics";

export type TrackFn = (params: TrackPayload, dedup?: boolean, shouldUpdate?: boolean) => void;

type AnalyticsContextType = {
  track: TrackFn,
  onFinishLesson: TrackFn,
  submitPendingFinish: () => Promise<void>,
  isReadyToComplete: boolean,
};

export const AnalyticsContext = createContext<AnalyticsContextType | null>(null);

export const useAnalyticsContext = () => {
  const ctx = useContext(AnalyticsContext);
  if (!ctx) throw new Error("useAnalyticsContext must be used within AnalyticsProvider");
  return ctx;
};
